import { useState, useEffect } from 'react';
import { PRINTER_KEY } from '../../../utils/storageKeys';

export const useOrderPrinter = (
  availablePrinters,
  selectedPrinter,
  selectPrinter,
  printLabel,
  showSnackbar
) => {
  const [printerModalOpen, setPrinterModalOpen] = useState(false);
  const [isClosingPrinterModal, setIsClosingPrinterModal] = useState(false);
  const [bridgeInstallModalOpen, setBridgeInstallModalOpen] = useState(false);
  const [pendingAutoPrint, setPendingAutoPrint] = useState(false);
  const [autoPrintEnabled, setAutoPrintEnabled] = useState(false);

  useEffect(() => {
    const savedPrinter = localStorage.getItem(PRINTER_KEY);
    if (
      savedPrinter &&
      !selectedPrinter &&
      availablePrinters.length > 0 &&
      !printerModalOpen
    ) {
      try {
        const parsed = JSON.parse(savedPrinter);
        const found = availablePrinters.find((p) => p.name === parsed.name);
        if (found) {
          selectPrinter(found);
        }
      } catch {}
    }
  }, [availablePrinters, selectedPrinter, selectPrinter, printerModalOpen]);

  const handleSelectPrinter = async (printer, autoprint) => {
    const wasPendingAutoPrint = pendingAutoPrint;

    setIsClosingPrinterModal(true);
    selectPrinter(printer);
    setPrinterModalOpen(false);
    setPendingAutoPrint(false);

    if (printer) {
      localStorage.setItem(PRINTER_KEY, JSON.stringify(printer));
    }
    if (typeof autoprint === "boolean") setAutoPrintEnabled(autoprint);

    await new Promise((resolve) => setTimeout(resolve, 200));

    if (wasPendingAutoPrint) {
      const zplData = "^XA^FO50,50^ADN,36,20^FDImpressão de Teste^FS^XZ";
      printLabel(zplData)
        .then(() => {})
        .catch((error) => {
          showSnackbar(
            "Erro na impressão: " + (error.message || error),
            "error"
          );
        });
    }

    setTimeout(() => {
      setIsClosingPrinterModal(false);
    }, 500);
  };

  const handleClosePrinterModal = () => {
    setIsClosingPrinterModal(true);
    setPrinterModalOpen(false);
    setPendingAutoPrint(false);
    setAutoPrintEnabled(false);

    setTimeout(() => {
      setIsClosingPrinterModal(false);
    }, 500);
  };

  const handlePrintLabelWithPrinterCheck = (handlePrintLabel) => {
    if (!selectedPrinter && !isClosingPrinterModal) {
      if (!printerModalOpen) {
        setPrinterModalOpen(true);
        setPendingAutoPrint(true);
      }
      return;
    }
    handlePrintLabel();
  };

  return {
    printerModalOpen,
    setPrinterModalOpen,
    bridgeInstallModalOpen,
    setBridgeInstallModalOpen,
    autoPrintEnabled,
    setAutoPrintEnabled,
    pendingAutoPrint,
    setPendingAutoPrint,
    isClosingPrinterModal,
    handleSelectPrinter,
    handleClosePrinterModal,
    handlePrintLabelWithPrinterCheck,
  };
};